import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import piexif from 'piexifjs'
import './modal-image-capture.css'



export default class ModalImageCapture extends React.Component {
    constructor(props) {
        super(props)
        this._snap = this._snap.bind(this)
        this._fileSelected = this._fileSelected.bind(this)
        this._close = this._close.bind(this)
        this.state = {
            uploadImage: null,
            showWrongFormat: false,
            imageFormatUsed: ''
        }
    }

    componentWillMount() {
        //check media capabilities
        // this.getUserMedia = navigator.getUserMedia ||
        //     navigator.webkitGetUserMedia ||
        //     navigator.mozGetUserMedia ||
        //     navigator.msGetUserMedia

        // if (this.getUserMedia) {
        //     let supportedConstraints = navigator.mediaDevices.getSupportedConstraints()
        //     this.aspectRatio = supportedConstraints.aspectRatio
        // }
    }

    componentDidMount() {
        this._startCapture()
    }

    componentWillUnmount() {
        this._stopCapture()
    }

    _stopCapture() {
        if (this.video)
            this.video.pause()

        if (this.mediaStream && this.mediaStream.active) {
            let track = this.mediaStream.getVideoTracks()[0]
            track.stop()
            delete this.mediaStream
        }
    }

    _startCapture() {
        if (this.video && this.getUserMedia) {
            let gum = this.getUserMedia.bind(navigator)
            gum({ audio: false, video: true }, (stream) => {
                this.mediaStream = stream
                this.video.src = window.URL.createObjectURL(stream)
                this.video.play()
            }, () => {
                // TODO: implement failover
            })
        } else {            
            // TODO: implement failover
        }
    }

    _snap() {
        let image = this.state.uploadImage
        if (this.mediaStream && this.mediaStream.active && this.video && this.canvas) {
            this._stopCapture()
            this.canvas.height = this.canvas.width * (this.video.videoHeight / this.video.videoWidth)
            let ctx = this.canvas.getContext('2d')
            ctx.drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height)
            image = this.canvas.toDataURL('image/jpeg')
        }

        if (this.props.onClose)
            this.props.onClose(image, this.description ? this.description.value : null)

    }

    _fileSelected(e) {
        if (this.state.showWrongFormat) {this.setState({showWrongFormat: false})}      
        let reader = new FileReader()
        
        reader.onload = (readerEvent) => {
            try{
                
                let exif = piexif.load(readerEvent.target.result)
                
                let orientation = exif["0th"][piexif.ImageIFD.Orientation]
                
                let image = new Image()
                image.onload = (e) => {
                    
                    let resized = this._resizeImage(e.target, orientation)
                    this.setState({ uploadImage: resized })
                }
                image.src = readerEvent.target.result
                this.setState({ uploadImage: readerEvent.target.result })            
            }
            catch(err){
                
                var image = readerEvent.target.result
                this.setState({showWrongFormat: true})
                this.setState({imageFormatUsed: image.substr(11, 3)})                                
            }
        }

        reader.readAsDataURL(e.target.files[0])
    }

    _resizeImage(image, orientation) {
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');
        const MAX_WIDTH = 3200;
        const MAX_HEIGHT = 2400;
        let width = image.width;
        let height = image.height;

        // Adjust dimensions to maintain aspect ratio
        if (width > height) {
            if (width > MAX_WIDTH) {
                height = Math.round(height * (MAX_WIDTH / width));
                width = MAX_WIDTH;
            }
        } else {
            if (height > MAX_HEIGHT) {
                width = Math.round(width * (MAX_HEIGHT / height));
                height = MAX_HEIGHT;
            }
        }

        canvas.width = width;
        canvas.height = height;

        ctx.save();

        // Handle orientation adjustments
        if (orientation) {
            if (orientation > 4) {
                canvas.width = height;
                canvas.height = width;
            }
            switch (orientation) {
                case 2: ctx.translate(width, 0); ctx.scale(-1, 1); break; // Mirror horizontally
                case 3: ctx.translate(width, height); ctx.rotate(Math.PI); break; // Rotate 180°
                case 4: ctx.translate(0, height); ctx.scale(1, -1); break; // Mirror vertically
                case 5: ctx.rotate(0.5 * Math.PI); ctx.scale(1, -1); break; // Mirror and rotate 90° CW
                case 6: ctx.rotate(0.5 * Math.PI); ctx.translate(0, -height); break; // Rotate 90° CW
                case 7: ctx.rotate(0.5 * Math.PI); ctx.translate(width, -height); ctx.scale(-1, 1); break; // Mirror and rotate 90° CCW
                case 8: ctx.rotate(-0.5 * Math.PI); ctx.translate(-width, 0); break; // Rotate 90° CCW
                default: break;
            }
        }

        ctx.drawImage(image, 0, 0, width, height);
        ctx.restore();

        // Return resized image as a data URL
        return canvas.toDataURL("image/jpeg");
    }

    _close() {
        this.props.onClose(null, '')
    }

    render() {
        return (


            <Modal.Dialog>
                <Modal.Header closeButton onHide={this._close}>
                    <Modal.Title>Ta bilde</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className="vat-modal-image-capture">

                        <div className="fallback-container">
                            <div className="fallback-image-container">
                                <img src={this.state.uploadImage} alt="" width="60%" height="60%" />
                            </div>
                            <div className="fallback-input-container hoeyde48">
                                {this.state.uploadImage ?
                                    <label className="upload" htmlFor="test">Erstatt bilde</label>
                                    : <label className="upload" htmlFor="test">Ta bilde</label>
                                }

                                {/* accept="image/*;capture=camera" */}
                                <input id="test" type="file" accept="image/*;capture=camera" className="hoeyde48" onChange={this._fileSelected}
                                    style={{ display: 'none', float: 'left' }} />
                            </div>
                        </div>
                        {this.state.showWrongFormat ?
                        <div className="alert alert-danger" role="alert">Kun bilder av typen JPG støttes. Hvis du har valgt et lagret bilde kontroller at den slutter på '.jpg'. 
                        Hvis bildet er tatt direkte fra kamera på mobil, kontroller at mobilkameraet bruker bildeformat JPG.</div>
                        : <div/>
                        }
                        {this.props.visBilekommentar ? 
                            <input type="text" className="form-control hoeyde38" placeholder="Skriv bildekommentar her"
                            ref={input => this.description = input} maxLength="250" />

                            
                            : <div/>}
                        
                        <div className="buttonContainer">
                            <button className="btn btn-block btn-primary hoeyde48" onClick={this._snap}>
                                OK
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal.Dialog>
        )
    }
}

ModalImageCapture.propTypes = {
    onClose: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/felles/Bilder/modal-image-capture.jsx